module.exports = __webpack_public_path__ + "static/img/logo4.6ca511c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/logo4.png
// module id = APT0
// module chunks = 1